(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-size-chart"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    const charts = document.querySelectorAll(".custom-size-chart");

    charts.forEach(chart => {
      const tabs = chart.querySelectorAll(".size-chart__tab-btn");
      const panels = chart.querySelectorAll(".size-chart__panel");

      tabs.forEach(tab => {
        tab.addEventListener("click", function() {
          const target = this.dataset.tabTarget;

          tabs.forEach(t => t.classList.remove("active"));
          panels.forEach(p => p.classList.remove("active"));

          this.classList.add("active");
          const activePanel = chart.querySelector(target);
          if (activePanel) {
            activePanel.classList.add("active");
          }
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
